// extracted by mini-css-extract-plugin
export default {"container":"GameList_container__fES75","game_list_horizontal":"GameList_game_list_horizontal__K-bXE","game_list":"GameList_game_list__6SU5X"};